<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MGNhW4/tc-custom/9781423640547.jpg?1709781778817" alt="This image is the cover for the book Le French Oven"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Le French Oven
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The author of <i>French Comfort Food</i> presents an array of authentic recipes using the cocotte—French cuisine’s answers to the Dutch oven.</b><br/>  <br/> Cast iron pots have been a mainstay of French cuisine for generations. In <i>Le French Oven</i>, Hillary Davis shares her love for this traditional cookware and the many delectable French foods that can be made with it. Using various techniques such as braising, stewing, roasting, baking, stovetop, and frying, <i>Le French Oven</i> features recipes for appetizers, soups, main courses, desserts, and more.<br/>  <br/> Davis also includes information about the major French made cocotte brands, and how to use them to create fabulous dishes such as Warm Mushroom Custards with Garlic Toast, French Carrot Rice Soup, Basque-Style Paella, Two-Hands Praying Rack of Lamb Roast, Lemony Braised Chicken with Green Olives, and Beef Pot-au-Feu. The sweet recipes include fabulous fare such as Raspberry Clafoutis and Hot Brandied Peaches Over Ice Cream.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hillary Davis, Steven Rothfeld
      </h2>
      
      <p class="authorDescription body article"><B>Hillary Davis, </B>food journalist, cooking instructor, and writer and creator of the popular food blog Marche Dimanche, is a long-time food columnist and restaurant critic for <I>New Hampshire Magazine,</I> and her work has been featured in many national and international magazine and website articles. She is also the author of <I>Cuisine Ni&ccedil;oise</I> and has been a food and travel lecturer on Royal Caribbean and Celebrity cruise lines. She lives in New Hampshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43592480